/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordRequestDto
 */
export interface ResetPasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    newPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    $type?: ResetPasswordRequestDtoTypeEnum;
}


/**
 * @export
 */
export const ResetPasswordRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoResetPasswordRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Account.Dto.ResetPasswordRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ResetPasswordRequestDtoTypeEnum = typeof ResetPasswordRequestDtoTypeEnum[keyof typeof ResetPasswordRequestDtoTypeEnum];


/**
 * Check if a given object implements the ResetPasswordRequestDto interface.
 */
export function instanceOfResetPasswordRequestDto(value?: unknown): value is ResetPasswordRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ResetPasswordRequestDtoTypeEnum)[0];
}

export function ResetPasswordRequestDtoFromJSON(json: any): ResetPasswordRequestDto {
    return ResetPasswordRequestDtoFromJSONTyped(json, false);
}

export function ResetPasswordRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ResetPasswordRequestDtoToJSON(value?: ResetPasswordRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'email': value.email,
        'token': value.token,
        'newPassword': value.newPassword,
        '$type': value.$type,
    });
}

